<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '480px' }"
    header="Fomulário de Equipamentos"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="fluid">
      <div class="field">
        <label for="name">Nome</label>
        <InputText
          id="name"
          v-model="v$.equipament.name.$model"
          maxlength="100"
          placeholder="Digite o nome do equipamento"
          :class="{ 'p-invalid': submitted && v$.equipament.name.$invalid }"
        />
        <small class="p-error" v-if="submitted && v$.equipament.name.$invalid"
          >Nome do equipamento é obrigatório.</small
        >
      </div>
      <div class="field">
        <label for="rp">RP</label>
        <InputText
          id="rp"
          v-model="equipament.rp"
          placeholder="Digite o número da rp (Máx. 50 caracteres)"
        />
      </div>
      <div class="field">
        <label for="serial">Serial</label>
        <InputText
          id="serial"
          v-model="equipament.serial"
          placeholder="Digite o número do serial (Máx. 50 caracteres)"
        />
      </div>
      <!--Verificar status-->
    </div>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.equipament.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Equipament from "../../../../src/models/internal/equipament";

//Services
import EquipamentService from "../../../../src/service//internal/equipament/equipament_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["equipamentSelected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      equipaments: [],
      equipament: new Equipament(),
      submitted: false,
      equipamentService: new EquipamentService(),
    };
  },
  created() {},
  validations() {
    return {
      equipament: new Equipament().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.equipament.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.equipament.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.equipament.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      this.equipamentService
        .create(this.equipament)
        .then((data) => {
          if (data.status === 201) {
            this.$msgSuccess(data);
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      this.equipamentService
        .update(this.equipament)
        .then((data) => {
          if (data.status === 200) {
            this.$msgSuccess(data);
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.equipament = new Equipament();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.equipament = this.equipamentSelected;
    },
  },
};
</script>
<style scoped></style>
